<template>
  <InfoManagement/>
</template>
<script>
import InfoManagement from 'place/management/infoManagement.vue'
export default {
    components:{
      InfoManagement
    }
}
</script>